// extracted by mini-css-extract-plugin
export default {"preview":"m5a2Sth4vc2fzNwTVA80"};